module.exports = __webpack_public_path__ + "static/media/now-logo.3e82acb6.png";